import { useMemo } from 'react';
import {
  AG_GRID_CURRENCY_CELL_RENDERER_KEY,
  AG_GRID_OPTION_GROUP_KEY,
  AG_GRID_OPTION_MARK_KEY,
  AG_GRID_OPTION_PRICE_QUOTE_KEY,
  AG_GRID_OPTION_STRIKE_PRICE_KEY,
  AgGridAmountInput,
  AgGridButton,
  AgGridCheckbox,
  AgGridCurrency,
  AgGridDateRangeFilter,
  AgGridDateTimePicker,
  AgGridFormattedNumber,
  AgGridGroupToggleHeader,
  AgGridHamburgerMenu,
  AgGridIconButton,
  AgGridInput,
  AgGridLoadingOverlay,
  AgGridMeter,
  AgGridMultiSelectDropdown,
  AgGridNoRowsOverlay,
  AgGridOptionGroupCell,
  AgGridOptionMark,
  AgGridOptionPriceQuote,
  AgGridOptionStrikePrice,
  AgGridPrice,
  AgGridProcessStep,
  AgGridSearchSelectDropdown,
  AgGridSecurity,
  AgGridSize,
  AgGridToggle,
  AgGridTooltipHeader,
  AgGridWarning,
  AgGridWarningHeader,
} from '../AgGrid';
import { AG_GRID_FULL_WIDTH_GROUP_ROW, AgGridFullWidthGroupRow } from '../AgGrid/AgGridFullWidthGroupRow';
import { AG_GRID_BLOTTER_TOOLTIP_KEY, AgGridBlotterTooltip } from './tooltips/AgGridBlotterTooltip';

/**
 * Builds the components map passed to `<AgGridReact components={...}/>`. Shared by
 * `BlotterTable` and `MobileDataTable` so the renderer registry stays in one place
 * — drift between the two would silently fall back to text rendering for any
 * column whose renderer is missing.
 */
export function useBlotterComponents(extraComponents?: Record<string, any>): Record<string, any> {
  return useMemo(() => {
    return {
      buttonColumn: AgGridButton,
      checkbox: AgGridCheckbox,
      dateRangeFilter: AgGridDateRangeFilter,
      dateTimePicker: AgGridDateTimePicker,
      hamburgerMenuColumn: AgGridHamburgerMenu,
      iconButtonColumn: AgGridIconButton,
      loadingOverlay: AgGridLoadingOverlay,
      noRowsOverlay: AgGridNoRowsOverlay,
      meterColumn: AgGridMeter,
      priceColumn: AgGridPrice,
      formattedNumberColumn: AgGridFormattedNumber,
      processStepColumn: AgGridProcessStep,
      sizeColumn: AgGridSize,
      iconButton: AgGridIconButton,
      input: AgGridInput,
      amountInput: AgGridAmountInput,
      toggle: AgGridToggle,
      searchSelectDropdown: AgGridSearchSelectDropdown,
      multiSelectDropdown: AgGridMultiSelectDropdown,
      [AG_GRID_CURRENCY_CELL_RENDERER_KEY]: AgGridCurrency,
      securityColumn: AgGridSecurity,
      warningColumn: AgGridWarning,
      warningHeader: AgGridWarningHeader,
      groupToggleHeader: AgGridGroupToggleHeader,
      [AG_GRID_OPTION_STRIKE_PRICE_KEY]: AgGridOptionStrikePrice,
      [AG_GRID_OPTION_PRICE_QUOTE_KEY]: AgGridOptionPriceQuote,
      [AG_GRID_OPTION_MARK_KEY]: AgGridOptionMark,
      [AG_GRID_OPTION_GROUP_KEY]: AgGridOptionGroupCell,
      [AG_GRID_FULL_WIDTH_GROUP_ROW]: AgGridFullWidthGroupRow,
      tooltipHeader: AgGridTooltipHeader,
      [AG_GRID_BLOTTER_TOOLTIP_KEY]: AgGridBlotterTooltip,

      ...extraComponents,
    };
  }, [extraComponents]);
}
